import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=c72c6dd2&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=c72c6dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72c6dd2",
  null
  
)

export default component.exports